import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import { useWindowSize } from "../hooks";
import { ChevronNormalDown, Facebook, Instagram, Odnoklassniki, Vk, Youtube } from "../icons";
import { TextBase } from "../internal/TextBase";
import { isObject } from "../utils/type";
import styles from './FooterB2B.css';
var cx = classNames.bind(styles);
var defaultData = {
  options: [{
    title: 'S7 profi',
    suboptions: ['О программе', 'Правила программы', 'Вопросы и ответы']
  }, {
    title: 'Клиентам',
    suboptions: ['Спецпредложения', 'Обратная связь', 'Исследования']
  }, {
    title: 'Другие услуги',
    suboptions: ['Бронирование отеля', 'Аренда авто', 'Трансфер']
  }],
  social: {},
  support: {
    phone: '8 800 500-50-77',
    email: 'corp.support@s7.ru'
  },
  partnership: {
    title: 'По вопросам партнерства:',
    email: 'profi.partners@s7.ru'
  },
  settlement: {
    title: 'По вопросам взаиморасчетов:',
    email: 'corp.doc@s7.ru'
  },
  copyright: "\xA9 S7 Airlines, ".concat(new Date().getFullYear())
};
var defaultSuboptions = [];
var ICONS_BY_NAME = {
  facebook: /*#__PURE__*/React.createElement(Facebook, {
    size: "md"
  }),
  instagram: /*#__PURE__*/React.createElement(Instagram, {
    size: "md"
  }),
  odnoklassniki: /*#__PURE__*/React.createElement(Odnoklassniki, {
    size: "md"
  }),
  vk: /*#__PURE__*/React.createElement(Vk, {
    size: "md"
  }),
  youtube: /*#__PURE__*/React.createElement(Youtube, {
    size: "md"
  })
};

var getOptionValue = function getOptionValue(val, Component, props) {
  if (isObject(val)) {
    return val.href ? /*#__PURE__*/React.createElement("a", _extends({
      href: val.href,
      className: cx('link')
    }, val.isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {
      target: val.target,
      rel: val.rel
    }), /*#__PURE__*/React.createElement(Component, props, val.text)) : /*#__PURE__*/React.createElement(Component, props, val.text);
  }

  return /*#__PURE__*/React.createElement(Component, props, val);
};

var Option = /*#__PURE__*/memo(function Option(_ref) {
  var xs = _ref.xs,
      title = _ref.title,
      isOpen = _ref.isOpen,
      _ref$suboptions = _ref.suboptions,
      suboptions = _ref$suboptions === void 0 ? defaultSuboptions : _ref$suboptions;

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  useEffect(function () {
    if (open) {
      setOpen(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [xs]);
  var allowSuboptions = !xs || xs && open;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('option', {
      option_open: open
    })
  }, xs ? {
    onClick: function onClick() {
      return setOpen(!open);
    }
  } : {}), /*#__PURE__*/React.createElement("div", {
    className: cx('option_title')
  }, /*#__PURE__*/React.createElement(TextBase, {
    size: "l",
    weight: !xs ? 'semibold' : undefined
  }, title), xs && /*#__PURE__*/React.createElement("span", {
    className: cx('chevron', {
      chevron_open: open
    })
  }, /*#__PURE__*/React.createElement(ChevronNormalDown, null))), allowSuboptions && /*#__PURE__*/React.createElement("div", {
    className: cx('suboptions')
  }, suboptions.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('suboption'),
      key: "".concat(title, "_").concat(index + 1)
    }, getOptionValue(item, TextBase, {
      size: 'l',
      color: 'N100',
      as: 'span',
      noWrap: true
    }));
  })));
});

var FooterB2B = function FooterB2B(_ref2) {
  var _data$support, _data$support2, _data$settlement, _data$settlement2, _data$partnership, _data$partnership2;

  var propsData = _ref2.data,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var data = useMemo(function () {
    return _objectSpread(_objectSpread({}, defaultData), propsData);
  }, [propsData]);
  var breakpoint = useMemo(function () {
    var xs = width <= 767;
    return {
      xs: xs
    };
  }, [width]);
  var commonTextProps = useMemo(function () {
    return {
      size: !breakpoint.xs ? 'm' : undefined
    };
  }, [breakpoint.xs]);
  var getSocialIcon = useCallback(function (name) {
    var _data$social;

    var params = (data === null || data === void 0 ? void 0 : (_data$social = data.social) === null || _data$social === void 0 ? void 0 : _data$social[name]) || {};
    var Component = params.href ? 'a' : 'button';

    var iconProps = _objectSpread(_objectSpread(_objectSpread({}, params), params.isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {
      target: params.target,
      rel: params.rel
    }), !params.href ? {
      type: 'button'
    } : {});

    return /*#__PURE__*/React.createElement(Component, _extends({
      className: cx('social_icon', "social_icon_".concat(name))
    }, iconProps), ICONS_BY_NAME[name]);
  }, [data]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root')
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('contentWrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('left')
  }, ((data === null || data === void 0 ? void 0 : data.options) || []).map(function (item) {
    return /*#__PURE__*/React.createElement(Option, _extends({}, _objectSpread(_objectSpread({}, item), breakpoint), {
      key: item.title
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('right')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('right_item')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('support')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('support_phone')
  }, getOptionValue(data === null || data === void 0 ? void 0 : (_data$support = data.support) === null || _data$support === void 0 ? void 0 : _data$support.phone, 'span')), /*#__PURE__*/React.createElement("div", {
    className: cx('support_email')
  }, getOptionValue(data === null || data === void 0 ? void 0 : (_data$support2 = data.support) === null || _data$support2 === void 0 ? void 0 : _data$support2.email, TextBase, commonTextProps)))), /*#__PURE__*/React.createElement("div", {
    className: cx('right_item')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('settlement')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('settlement_title')
  }, getOptionValue(data === null || data === void 0 ? void 0 : (_data$settlement = data.settlement) === null || _data$settlement === void 0 ? void 0 : _data$settlement.title, TextBase, _objectSpread(_objectSpread({}, commonTextProps), {}, {
    color: 'N100'
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('settlement_email')
  }, getOptionValue(data === null || data === void 0 ? void 0 : (_data$settlement2 = data.settlement) === null || _data$settlement2 === void 0 ? void 0 : _data$settlement2.email, TextBase, commonTextProps)))), /*#__PURE__*/React.createElement("div", {
    className: cx('right_item')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('partnership')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('partnership_title')
  }, getOptionValue(data === null || data === void 0 ? void 0 : (_data$partnership = data.partnership) === null || _data$partnership === void 0 ? void 0 : _data$partnership.title, TextBase, _objectSpread(_objectSpread({}, commonTextProps), {}, {
    color: 'N100'
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('partnership_email')
  }, getOptionValue(data === null || data === void 0 ? void 0 : (_data$partnership2 = data.partnership) === null || _data$partnership2 === void 0 ? void 0 : _data$partnership2.email, TextBase, commonTextProps))))))), /*#__PURE__*/React.createElement("div", {
    className: cx('footer')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('footer_left')
  }, /*#__PURE__*/React.createElement(TextBase, {
    size: "s"
  }, data === null || data === void 0 ? void 0 : data.copyright)), /*#__PURE__*/React.createElement("div", {
    className: cx('footer_right')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('social')
  }, getSocialIcon('facebook'), getSocialIcon('instagram'), getSocialIcon('odnoklassniki'), getSocialIcon('vk'), getSocialIcon('youtube')))));
};

export default FooterB2B;